// Reads the attribute schema: derives per-command ordering and grouping from the
// numeric suffix the backend appends to each name, and builds the field labels.

import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

// The backend suffixes each attribute name with its position in commands_flow
// (index * 2 + 1), so 'karmak_account_number1' belongs to the first command.
// Attributes with no digits inherit the previous attribute's index.
//
// initialIndex differs per screen and is observable: the location settings page
// seeds it with '1', the integration settings page with '0'.
export const normalizeSchema = (
  schema = [],
  commandsFlow = [],
  { initialIndex = '1' } = {},
) => {
  let prevAttrIndex = initialIndex;

  return schema.map((attribute) => {
    const match = String(attribute.name).match(/\d+/);
    const attrIndex = match === null ? prevAttrIndex : match[0];
    prevAttrIndex = attrIndex;

    const commandIndex = (parseInt(attrIndex, 10) - 1) / 2;

    return {
      ...attribute,
      sort_index: commandIndex,
      command_name: `${commandsFlow[commandIndex]}${attrIndex}`,
    };
  });
};

export const sortSchema = (schema = []) => sortBy(schema, ['sort_index']);

export const groupSchema = (schema = [], key = 'command_name') =>
  groupBy(schema, key);

// Attribute names carry a numeric command suffix that is noise to the user, so the
// label drops the digits. When stripping them would make two fields look identical,
// the raw name is kept instead.
export const labelFor = (name, attributeNames = []) => {
  const withoutDigits = String(name).replace(/[0-9]/g, '');

  const collisions = attributeNames.filter((candidate) =>
    String(candidate).includes(withoutDigits),
  );

  return collisions.length > 1 ? name : withoutDigits;
};

export const namesOf = (attributes) =>
  Object.keys(attributes || {}).map((key) => attributes[key]?.name);

export const requiredNames = (groupedSchema) =>
  Object.values(groupedSchema || {})
    .flat()
    .filter((attribute) => attribute.required)
    .map((attribute) => attribute.name);
